(() => {
  if (customElements.get('everythings-farrked-multibuy')) return;

  class EverythingsFarrkedMultibuy extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.maximumQuantity = 11;
      this.farrkedLimit = Number(this.dataset.farrkedLimit || this.maximumQuantity);
      this.farrkedRule = this.dataset.farrkedRule || '';
      this.farrkedTwoPremiumCents = Number(this.dataset.farrkedTwoPremiumCents || 0);
      this.farrkedThreePremiumCents = Number(this.dataset.farrkedThreePremiumCents || 0);
      this.farrkedFourPremiumCents = Number(this.dataset.farrkedFourPremiumCents || 0);
      this.busy = false;
      this.submitButton = this.querySelector('[data-action="submit"]');
      this.status = this.querySelector('[data-status]');
      this.error = this.querySelector('[data-error]');
      this.choices = Array.from(this.querySelectorAll('[data-choice]')).map((element) => ({
        element,
        key: element.dataset.choice,
        variantId: element.dataset.variantId,
        available: element.dataset.available === 'true',
        qualifyingVodka: element.dataset.qualifyingVodka === 'true',
        quantity: Number(element.dataset.initialQuantity || 0),
      }));
      this.addEventListener('click', (event) => this.handleClick(event));
      this.render();
    }

    totalQuantity() {
      return this.choices.reduce((total, choice) => total + choice.quantity, 0);
    }

    qualifyingVodkaQuantity() {
      return this.choices.reduce(
        (total, choice) => total + (choice.qualifyingVodka ? choice.quantity : 0),
        0,
      );
    }

    farrkedQuantity() {
      const choice = this.choices.find((candidate) => candidate.key === 'everythings-farrked');
      return choice ? choice.quantity : 0;
    }

    bundleTotalCents() {
      const quantity = this.totalQuantity();
      if (quantity < 2) return 0;
      const baseCents = quantity === 2
        ? Number(this.dataset.tierTwoCents)
        : quantity === 3
          ? Number(this.dataset.tierThreeCents)
          : quantity * Number(this.dataset.tierFourPerBottleCents);
      const premiumCents = quantity === 2
        ? this.farrkedTwoPremiumCents
        : quantity === 3
          ? this.farrkedThreePremiumCents
          : this.farrkedFourPremiumCents;
      return baseCents + this.farrkedQuantity() * premiumCents;
    }

    formatMoney(cents) {
      return `A$${(cents / 100).toFixed(cents % 100 === 0 ? 0 : 2)} total`;
    }

    tierLabel(quantity) {
      if (this.farrkedRule && quantity >= 2) return this.formatMoney(this.bundleTotalCents());
      if (quantity === 2) return this.dataset.tierTwoLabel;
      if (quantity === 3) return this.dataset.tierThreeLabel;
      if (quantity >= 4) return this.dataset.tierFourLabel;
      return '';
    }

    rewardMessage(vodkaQuantity) {
      if (vodkaQuantity < 2) return 'No vodka gift yet.';
      if (vodkaQuantity === 2) return 'Vodka reward: Original sauce.';
      if (vodkaQuantity === 3) return 'Vodka rewards: Original sauce + Booze Bling.';
      return 'Vodka rewards: Booze Bling + STB Game.';
    }

    render() {
      const total = this.totalQuantity();
      const vodkaTotal = this.qualifyingVodkaQuantity();
      this.choices.forEach((choice) => {
        const output = choice.element.querySelector('[data-quantity]');
        const decrement = choice.element.querySelector('[data-action="decrement"]');
        const increment = choice.element.querySelector('[data-action="increment"]');
        if (output) output.textContent = String(choice.quantity);
        if (decrement) decrement.disabled = this.busy || choice.quantity === 0;
        if (increment) {
          increment.disabled = this.busy
            || !choice.available
            || total >= this.maximumQuantity
            || (choice.key === 'everythings-farrked' && choice.quantity >= this.farrkedLimit);
        }
      });
      this.dataset.selectedCount = String(total);
      this.dataset.qualifyingVodkaCount = String(vodkaTotal);
      this.submitButton.disabled = this.busy || total < 2;
      if (!this.busy) {
        this.submitButton.textContent = total >= 2
          ? `Add ${total} bottles · ${this.tierLabel(total)}`
          : 'Pick 2+ bottles to save';
      }
      if (this.status) {
        this.status.textContent = total >= 2
          ? `${total} bottles selected · ${this.tierLabel(total)} · ${this.rewardMessage(vodkaTotal)}`
          : `${total} bottles selected · Pick at least 2 to use multibuy pricing.`;
      }
    }

    handleClick(event) {
      const button = event.target.closest('button[data-action]');
      if (!button || !this.contains(button) || this.busy) return;
      const action = button.dataset.action;
      if (action === 'submit') {
        this.addSelected();
        return;
      }
      const choiceElement = button.closest('[data-choice]');
      const choice = this.choices.find((candidate) => candidate.element === choiceElement);
      if (!choice) return;
      const farrkedAtLimit = choice.key === 'everythings-farrked' && choice.quantity >= this.farrkedLimit;
      if (action === 'increment' && choice.available && !farrkedAtLimit && this.totalQuantity() < this.maximumQuantity) {
        choice.quantity += 1;
      } else if (action === 'decrement' && choice.quantity > 0) {
        choice.quantity -= 1;
      }
      this.render();
    }

    setBusy(busy) {
      this.busy = busy;
      this.render();
      if (busy) this.submitButton.textContent = 'Adding bottles…';
    }

    showError(message) {
      if (!this.error) return;
      this.error.textContent = message;
      this.error.hidden = false;
    }

    clearError() {
      if (!this.error) return;
      this.error.textContent = '';
      this.error.hidden = true;
    }

    async addSelected() {
      if (this.busy) return;
      const items = [];
      this.choices.forEach((choice) => {
        const quantity = choice.quantity;
        if (choice.available && choice.variantId && quantity > 0) {
          const item = { id: Number(choice.variantId), quantity };
          if (this.farrkedRule) {
            item.properties = {_bunsters_farrked_multibuy: this.farrkedRule};
          }
          items.push(item);
        }
      });
      if (items.reduce((total, item) => total + item.quantity, 0) < 2) return;

      this.clearError();
      this.setBusy(true);
      let addSucceeded = false;
      try {
        const addUrl = window.theme && window.theme.routes && window.theme.routes.cart_add_url
          ? window.theme.routes.cart_add_url
          : '/cart/add.js';
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        const body = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(body.description || 'Those bottles are unavailable right now. Please adjust your mix and try again.');
        addSucceeded = true;

        if (window.BunstersGiftEngine && typeof window.BunstersGiftEngine.reconcile === 'function') {
          await window.BunstersGiftEngine.reconcile({ refresh: true, openCart: true, reason: 'ef-multibuy-add' });
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {
            bubbles: true,
            detail: { openCart: true },
          }));
        }
      } catch (error) {
        this.showError(addSucceeded
          ? 'Your bottles were added, but the cart could not refresh. Open the cart to review them.'
          : (error.message || 'We could not add those bottles. Please try again.'));
      } finally {
        this.setBusy(false);
      }
    }
  }

  customElements.define('everythings-farrked-multibuy', EverythingsFarrkedMultibuy);
})();
